import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { ToolStorage } from "@app/tool/model/toolLocation.model";
import { Log } from "ng2-logger";
import {ToolPosition} from "@app/tool/model/tool-position.model";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-tool-location-picker',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ToolLocationPickerComponent,
            multi: true
        }
    ],
    templateUrl: './tool-location-picker.component.html',
    styleUrls: ['./tool-location-picker.component.scss']
})
export class ToolLocationPickerComponent implements OnInit {
    _logger = Log.create(ToolLocationPickerComponent.name);
    @ViewChild('positionInput', {static: true}) positionInput: ElementRef;

    @Input() setIndex = 1;
    @Input() formControl: UntypedFormControl;
    @Input() showErrors = false;
    @Input() toolName: string;

    // To be deleted - we will use toolPosition
    @Input() toolStorage = new ToolStorage();
    @Input() toolPosition = new ToolPosition();

    @Output() locationChange = new EventEmitter<ToolStorage>();

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    constructor(public translateService: TranslateService) {
    }

    ngOnInit() {
    }

    toUpperCase(event) {
        this.positionInput.nativeElement.value = event.target.value.toUpperCase().trim();
    }

    writeValue(obj: any): void {
        this.toolStorage = obj || [];
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    get hasError() {
        return this.formControl && this.formControl.errors && this.showErrors;
    }

    get value() {
        return this.toolStorage;
    }

    set liftNumber(value) {
        this.toolStorage.liftNumber = value;
        this.propagateChanges(this.toolStorage);
    }

    get liftNumber() {
        return this.toolPosition && this.toolPosition.lift ? this.toolPosition.lift.name :
            this.translateService.instant('generic.notStored');
    }

    set liftShelf(value) {
        this.toolStorage.liftShelf = value;
        this.propagateChanges(this.toolStorage);
    }

    get liftShelf() {
        return this.toolPosition && this.toolPosition.tray ? this.toolPosition.tray.name :
            this.translateService.instant('generic.notStored');
    }

    set shelfPosition(value) {
        this.toolStorage.shelfPosition = value;
        this.propagateChanges(this.toolStorage);
    }

    get shelfPosition() {
        return this.toolPosition && this.toolPosition.slot ? this.toolPosition.slot.name :
            this.translateService.instant('generic.notStored');
    }

    set cart(value) {
        this.toolStorage.cart = value;
        this.propagateChanges(this.toolStorage);
    }

    get cart() {
        return this.toolStorage.cart;
    }

    propagateChanges(value) {
        if (this.onChangeCallback) {
            this.onChangeCallback(value);
        }

        this.locationChange.emit(value);
    }

}
